<template>
  <Application>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <Kanban
      :isLoadingProject="projects.isLoadingProject"
      :isLoadingTasks="projects.isLoadingTasks"
      :boards="(projects.project || {}).boards || []"
      :tasks="(projects.project || {}).tasks || []"
      :info="(projects.project || {}).info || {}"
      @reload-tasks="reloadTasks"
      :schedule=true
    />
  </Application>
</template>

<script>
import { mapState } from 'vuex';
import Application from '@/components/Application/Application.vue';
import Kanban from '@/components/Projects/Kanban.vue';

export default {
  components: {
    Application,
    Kanban,
  },

  data() {
    return {
      loading: false,
      items: [
        { text: 'Dashboard', to: '/' },
        { text: 'Funil de vendas', active: true },
      ],
    };
  },

  async created() {
    this.fetchTasks();
  },

  computed: {
    ...mapState(['projects']),
  },

  methods: {
    fetchTasks() {
      this.$store.dispatch('projects/fetchProjectInfo', {
        userId: this.user.uid,
        companyId: this.user.company_id,
        filterByUser: true,
      });
    },

    reloadTasks() {
      this.fetchTasks();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
